import { render, staticRenderFns } from "./tbxbtjzbhxr.vue?vue&type=template&id=5b877b44&scoped=true&"
import script from "./tbxbtjzbhxr.vue?vue&type=script&lang=js&"
export * from "./tbxbtjzbhxr.vue?vue&type=script&lang=js&"
import style0 from "./tbxbtjzbhxr.vue?vue&type=style&index=0&id=5b877b44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b877b44",
  null
  
)

export default component.exports